import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/creators/{creatorId}/user-workflows/count';
type THIS_API = ApiDefinition['/creators/{creatorId}/user-workflows/count']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getUserWorkflowsCountGroupByWorkflows = async ({
  creatorId,
}: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getUserWorkflowsCountGroupByWorkflows;
